import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import ItemList from 'flarum/common/utils/ItemList';
import listItems from 'flarum/common/helpers/listItems';
import IndexPage from 'flarum/forum/components/IndexPage';
import Select from 'flarum/common/components/Select';
import Button from 'flarum/common/components/Button';

import LessonPlanDirectoryList from './LessonPlanDirectoryList';
import LessonPlanDirectoryState from '../states/LessonPlanDirectoryState';

import SubmitSuggestionModal from './SubmitSuggestionModal';

import LoadingIndicator from 'flarum/common/components/LoadingIndicator';

/**
 * This page re-uses Flarum's IndexPage CSS classes
 */
export default class LessonPlanDirectoryPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);

    app.setTitle('Lesson Plans');
    app.setTitleCount(0);

    this.state = new LessonPlanDirectoryState({});

    this.state.refreshParams({
      // ...app.search.params(),
      ...{
        q: m.route.param('q'),
        age_group: m.route.param('age_group'),
        activity_type: m.route.param('activity_type'),
        developmental_area: m.route.param('developmental_area'),
      },
    });

    this.q = m.route.param('q');

    // this.activityTypes[1] = 'Sensory';
    // this.activityTypes[2] = 'Language and literacy';
    // this.activityTypes[3] = 'STEM';
    // this.activityTypes[4] = 'Art and crafts';
    // this.activityTypes[5] = 'Music and movement';
    // this.activityTypes[6] = 'Outdoor play';
    // this.processing = true;

    // this.activityTypes = this.state.activityTypes;

    this.loading = true;

    app.store.find('lesson-plan-activity-types').then((activityTypes) => {
      this.activityTypes = activityTypes;
      this.loading = false;
      m.redraw();
    });

    app.store.find('lesson-plan-developmental-areas').then((developmentalAreas) => {
      this.developmentalAreas = developmentalAreas;
      this.loading = false;
      m.redraw();
    });

    this.bodyClass = 'LessonPlanDirectoryPage';

    app.history.push('lesson-plans', app.translator.trans('td-lesson-plans.forum.header.back_to_lesson_plans_directory_tooltip'));
  }

  view() {
    if (this.loading) {
      return LoadingIndicator.component();
    }

    return (
      <div className="IndexPage LessonPlanDirectory">
        {IndexPage.prototype.hero()}
        <div className="container LessonPlansWrap">
          <div className="sideNavContainer">
            <nav>
              <div className="IndexPage-nav sideNav">
                <div>Filters:</div>
                <ul>{listItems(this.sidebarItems().toArray())}</ul>
              </div>
            </nav>
            <div className="IndexPage-results sideNavOffset">
              <div className="IndexPage-toolbar">
                {/* <ul className="IndexPage-toolbar-view">{listItems(this.viewItems().toArray())}</ul> */}
                {this.searchForm()}
              </div>
              <LessonPlanDirectoryList state={this.state} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  /**
   * Our own sidebar. Re-uses Index.sidebarItems as the base
   * Elements added here will only show up on the directory page
   *
   * @return {ItemList}
   */
  sidebarItems() {
    const items = new ItemList();

    const AgeGroupFilter = this.state.AgeGroupFilter();
    const age_group_options = {};
    for (const i in AgeGroupFilter) {
      age_group_options[i] = app.translator.trans('td-lesson-plans.lib.agegroup.' + i);
    }
    items.add(
      'age_group',
      Select.component({
        options: age_group_options,
        value: this.state.getParams().age_group || 'default',
        // onchange: this.changeParams.bind(this),
        onchange: (value) => {
          this.updateParams({ age_group: value });
        },
      }),
      100
    );

    const activityTypes = [];
    activityTypes[0] = '- All activity types -';
    if (undefined != this.activityTypes) {
      this.activityTypes.map((activityType) => {
        activityTypes[activityType.id()] = activityType.title();
      });
    }

    items.add(
      'activity_type',
      Select.component({
        options: activityTypes,
        value: this.state.getParams().activity_type || '0',
        onchange: (value) => {
          this.updateParams({ activity_type: value });
        },
      })
    );

    const developmentalAreas = [];
    developmentalAreas[0] = '- All developmental areas -';
    if (undefined != this.developmentalAreas) {
      this.developmentalAreas.map((developmentalArea) => {
        developmentalAreas[developmentalArea.id()] = developmentalArea.title();
      });
    }

    items.add(
      'developmental_area',
      Select.component({
        options: developmentalAreas,
        value: this.state.getParams().developmental_area || '0',
        onchange: (value) => {
          this.updateParams({ developmental_area: value });
        },
      })
    );

    if (app.session.user) {
      items.add(
        'submit_suggestion',
        <Button className="Button Button--primary" onclick={() => app.modal.show(SubmitSuggestionModal)}>
          Suggest Lesson Plan
        </Button>
      );
    }

    return items;

    /* const items = IndexPage.prototype.sidebarItems();

    items.setContent(
      'nav',
      SelectDropdown.component(
        {
          buttonClassName: 'Button',
          className: 'App-titleControl',
        },
        this.navItems().toArray()
      )
    );

    return items; */
  }

  /**
   * Our own sidebar navigation. Re-uses Index.navItems as the base
   * Elements added here will only show up on the directory page
   *
   * @return {ItemList}
   */
  navItems() {
    const items = IndexPage.prototype.navItems();
    const params = this.stickyParams();

    items.remove('allDiscussions');
    items.remove('following');
    items.remove('tags');
    items.remove('tag1');
    items.remove('separator');

    return items;
  }

  viewItems() {
    const items = new ItemList();

    return items;
  }

  searchForm() {
    return (
      <form onsubmit={this.onsubmit.bind(this)}>
        <div class="lesson-plans-search-form">
          <input
            className="input-search"
            name="q"
            value={this.q}
            oninput={(e) => (this.q = e.target.value)}
            placeholder="Search Lesson Plans..."
          ></input>
          <Button type="submit" className="btn-search" aria-label="Search">
            <i class="fas fa-search"></i>
          </Button>
        </div>
      </form>
    );
  }

  onsubmit(e) {
    e.preventDefault();
    this.updateParams({ q: this.q });
  }

  /* actionItems() {
    const items = new ItemList();

    items.add(
      'refresh',
      Button.component({
        title: app.translator.trans('td-lesson-plans.forum.page.refresh_tooltip'),
        icon: 'fas fa-sync',
        className: 'Button Button--icon',
        onclick: () => {
          this.state.refresh();
          if (app.session.user) {
            app.store.find('lesson-plans');
            m.redraw();
          }
        },
      })
    );

    return items;
  } */

  /**
   * Redirect to the index page using the given age_group parameter.
   *
   * @param {String} age_group
   */
  changeParams(age_group) {
    const params = this.params();

    if (age_group === 'default') {
      delete params.age_group;
    } else {
      params.age_group = age_group;
    }

    const routeParams = { ...params };
    delete routeParams.qBuilder;

    m.route.set(app.route('lesson_plans', routeParams));
  }

  updateParams(obj) {
    const params = this.params();

    let key = Object.keys(obj)[0];
    let value = obj[key];

    if (value === 'default' || value === '0') {
      delete params[key];
    } else {
      params[key] = value;
    }

    const routeParams = { ...params };
    delete routeParams.qBuilder;

    m.route.set(app.route('lesson_plans', routeParams));
  }

  stickyParams() {
    return {
      q: m.route.param('q'),
      age_group: m.route.param('age_group'),
      activity_type: m.route.param('activity_type'),
      developmental_area: m.route.param('developmental_area'),
    };
  }

  params() {
    return this.stickyParams();
  }
}
